import { useEffect } from "react";

const LoadExternalScripts = () => {
  useEffect(() => {
    if (!document.getElementById("vk-openapi-script")) {
      const script1 = document.createElement("script");
      script1.id = "vk-openapi-script";
      script1.src = "https://vk.com/js/api/openapi.js?168";
      script1.async = true;
      script1.onload = () => {
        window.dispatchEvent(new Event("vk-openapi-ready"));
      };

      document.body.appendChild(script1);
    } else if (window.VK && window.VK.Widgets) {
      window.dispatchEvent(new Event("vk-openapi-ready"));
    }

    return undefined;
  }, []);

  return null;
};

export default LoadExternalScripts;
